/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy } from '@dnd-kit/sortable';
import AmenityBox from './AmenityBox';
import SortableGridItem from './SortableGridItem';
import ajax from '../../../utils/ajaxHelper';
import useCommunityList from '../../../hooks/useCommunityList';

const AmenityGrid = ({
  filteredAmenities,
  isAccessible,
  publicView,
  amenities,
  setCommunityDetails,
  onAmenityUpdate,
  editFrom,
}) => {
  const { sortAmenities } = useCommunityList();
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  useEffect(() => {
    setItems(sortAmenities(filteredAmenities));
  }, [filteredAmenities]);
  // console.log(filteredAmenities, 'filteredAmenities filteredAmenities');

  const saveAmenitiesOrder = async (reorderedAmenities) => {
    try {
      const resp = await ajax.post(
        `community/update-amenities-order`,
        {
          reorderedAmenities,
        },
        {
          networkParams: { showLoader: false },
        },
      );
      // console.log('✅ Amenities have been reordered and changes were saved!', resp.data);
    } catch (err) {
      console.error('❌ Error updating amenity order:', err);
    }
  };

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveId(null);

    if (!over || active.id === over.id) return;

    const oldIndex = items.findIndex((item) => item?.id === active.id);
    const newIndex = items.findIndex((item) => item?.id === over.id);
    let updatedItems = arrayMove(items, oldIndex, newIndex);
    setItems(updatedItems);
    if (amenities?.length !== items?.length) {
      // Filtered view - need to update full amenities list
      updatedItems = [...sortAmenities(amenities)]; // full list

      // Find positions in full list
      const activeIndexFull = updatedItems.findIndex((item) => item?.id === active.id);
      const overIndexFull = updatedItems.findIndex((item) => item?.id === over.id);

      if (activeIndexFull !== -1 && overIndexFull !== -1) {
        updatedItems = arrayMove(updatedItems, activeIndexFull, overIndexFull);
      }
    }
    updatedItems = updatedItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
    await saveAmenitiesOrder(updatedItems.map(({ id, order }) => ({ id, order })));
    // set amenities to the new order
    setCommunityDetails((prev) => ({
      ...prev,
      amenities: updatedItems,
    }));
  };

  const activeAmenity = items.find((item) => item.id === activeId);

  return isAccessible && false ? (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={() => setActiveId(null)}
    >
      <SortableContext items={items?.map((item) => item?.id)} strategy={rectSortingStrategy}>
        <Grid container spacing={2} className="DragDropContainer">
          {items?.map((amenity) => (
            <SortableGridItem key={amenity?.id} id={amenity?.id} xs={12} sm={4}>
              <AmenityBox
                amenity={amenity}
                isAccessible={isAccessible}
                publicView={publicView}
                onAmenityUpdate={onAmenityUpdate}
                editFrom={editFrom}
              />
            </SortableGridItem>
          ))}
        </Grid>
      </SortableContext>

      <DragOverlay adjustScale style={{ transformOrigin: '0 0' }}>
        {activeAmenity ? (
          <div style={{ cursor: 'grabbing', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
            <AmenityBox
              amenity={activeAmenity}
              isAccessible={isAccessible}
              publicView={publicView}
              onAmenityUpdate={onAmenityUpdate}
              editFrom={editFrom}
            />
          </div>
        ) : (
          ''
        )}
      </DragOverlay>
    </DndContext>
  ) : (
    <Grid container spacing={2}>
      {items?.map((amenity) => (
        <Grid item xs={12} sm={4} key={amenity?.id}>
          <AmenityBox
            amenity={amenity}
            isAccessible={isAccessible}
            publicView={publicView}
            onAmenityUpdate={onAmenityUpdate}
            editFrom={editFrom}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AmenityGrid;
